const schema = {
  title: "Online Claim Form Details",
  description: "Form Selection",
  type: "object",

  //Remove when testing is complete
  required: [
    "region",
    "insuredPerilCode",
    "insuredPolicyNumber",
    "insuredName",
    "insuredtel",
    "clientEmail",
    "brokerage",
    "brokeremail",
    "claimtypeCat",
  ],
  properties: {
    region: {
      type: "string",
      title: "Region",
      enum: ["Gauteng", "Cape Town"]
    },
    insuredPerilCode: {
      type: "string",
      title: "Product Type",
       errorMessage: "Product Type captured is incorrect."
    },
    insuredPolicyNumber: { type: "string", title: "Policy Number" },
    insuredName: { type: "string", title: "Insured Name or Company Name" },
    insuredtel: { type: "string", title: "Insured Contact Number", minLength: 10 },
    clientEmail: { type: "string", title: "Insured Email", format: "email" },
    brokerage: { type: "string", title: "Brokerage" },
    brokerName: { type: "string", title: "Broker Contact Person" },
    brokeremail: { type: "string", title: "Broker Email", format: "email" },
    claimtypeCat: {
      type: "string",
      title: "What type of incident you want to submit claim for?",
      enum: ["Motor", "Non-Motor"]
    },
    subCoi: {
      type: "string",
      title: "Sub COI",
      enum: [],
      enumNames: []
    },
    claimMotorCauseOfLoss: {
      type: "string",
      title: "Peril",
      enum: [""]
    },
    claimNonMotorCauseOfLoss: {
      type: "string",
      title: "Peril"
    },
    CausedBy: {
      type: "string",
      title: "Cause Code",
      enum: [""]
    },
    NonMotorCausedBy: {
      type: "string",
      title: "Cause Code"
    },thirdparty: {
      type: "string",
      title: "Third Party Involved?",
      enum: ["Yes", "No"]
    }
  
  },
  dependencies: {
    claimtypeCat: {
      oneOf: [
        {
          properties: {
            claimtypeCat: { enum: ["Motor"] },
            claimMotor: {
              type: "string",
              title: "Motor item you want to submit claim for",
              enum: [],
              enumNames: []
            }
          },
          required: ["claimMotorCauseOfLoss", "CausedBy"]
        },
        {
          properties: {
            claimtypeCat: { enum: ["Non-Motor"] },
            claimNonMotor: {
              type: "string",
              title: "Non-Motor item you want to submit claim for",
              enum: [],
              enumNames: []
            }
          },
          required: ["claimNonMotorCauseOfLoss", "NonMotorCausedBy"]
        }
      ]
    }
  }
};

export default schema;